import { render, staticRenderFns } from "./CorrPricerConfig.vue?vue&type=template&id=904fb842&scoped=true&"
import script from "./CorrPricerConfig.vue?vue&type=script&lang=js&"
export * from "./CorrPricerConfig.vue?vue&type=script&lang=js&"
import style0 from "./CorrPricerConfig.vue?vue&type=style&index=0&id=904fb842&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "904fb842",
  null
  
)

export default component.exports